"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require("../generated/utils"),
    wrapperForImpl = _require.wrapperForImpl; // If we were to implement the MutationObserver by spec, the MutationObservers will not be collected by the GC because
// all the MO are kept in a mutation observer list (https://github.com/jsdom/jsdom/pull/2398/files#r238123889). The
// mutation observer list is primarily used to invoke the mutation observer callback in the same order than the
// mutation observer creation.
// In order to get around this issue, we will assign an increasing id for each mutation observer, this way we would be
// able to invoke the callback in the creation order without having to keep a list of all the mutation observers.


var mutationObserverId = 0; // https://dom.spec.whatwg.org/#mutationobserver

var MutationObserverImpl = /*#__PURE__*/function () {
  // https://dom.spec.whatwg.org/#dom-mutationobserver-mutationobserver
  function MutationObserverImpl(args) {
    _classCallCheck(this, MutationObserverImpl);

    var _args = _slicedToArray(args, 1),
        callback = _args[0];

    this._callback = callback;
    this._nodeList = [];
    this._recordQueue = [];
    this._id = ++mutationObserverId;
  } // https://dom.spec.whatwg.org/#dom-mutationobserver-observe


  _createClass(MutationObserverImpl, [{
    key: "observe",
    value: function observe(target, options) {
      var _this = this;

      if (("attributeOldValue" in options || "attributeFilter" in options) && !("attributes" in options)) {
        options.attributes = true;
      }

      if ("characterDataOldValue" in options & !("characterData" in options)) {
        options.characterData = true;
      }

      if (!options.childList && !options.attributes && !options.characterData) {
        throw new TypeError("The options object must set at least one of 'attributes', 'characterData', or 'childList' " + "to true.");
      } else if (options.attributeOldValue && !options.attributes) {
        throw new TypeError("The options object may only set 'attributeOldValue' to true when 'attributes' is true or " + "not present.");
      } else if ("attributeFilter" in options && !options.attributes) {
        throw new TypeError("The options object may only set 'attributeFilter' when 'attributes' is true or not " + "present.");
      } else if (options.characterDataOldValue && !options.characterData) {
        throw new TypeError("The options object may only set 'characterDataOldValue' to true when 'characterData' is " + "true or not present.");
      }

      var existingRegisteredObserver = target._registeredObserverList.find(function (registeredObserver) {
        return registeredObserver.observer === _this;
      });

      if (existingRegisteredObserver) {
        var _iterator = _createForOfIteratorHelper(this._nodeList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var node = _step.value;
            node._registeredObserverList = node._registeredObserverList.filter(function (registeredObserver) {
              return registeredObserver.source !== existingRegisteredObserver;
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        existingRegisteredObserver.options = options;
      } else {
        target._registeredObserverList.push({
          observer: this,
          options: options
        });

        this._nodeList.push(target);
      }
    } // https://dom.spec.whatwg.org/#dom-mutationobserver-disconnect

  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      var _iterator2 = _createForOfIteratorHelper(this._nodeList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          node._registeredObserverList = node._registeredObserverList.filter(function (registeredObserver) {
            return registeredObserver.observer !== _this2;
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._recordQueue = [];
    } // https://dom.spec.whatwg.org/#dom-mutationobserver-takerecords

  }, {
    key: "takeRecords",
    value: function takeRecords() {
      // TODO: revisit if https://github.com/jsdom/webidl2js/pull/108 gets fixed.
      var records = this._recordQueue.map(wrapperForImpl);

      this._recordQueue = [];
      return records;
    }
  }]);

  return MutationObserverImpl;
}();

module.exports = {
  implementation: MutationObserverImpl
};